import { Load } from './Styles';

const Loader = () => {
    return (
        <Load>
            <span>&#123;</span>
            <span>&#125;</span>
        </Load>
    );
};

export default Loader;
